import React, { useEffect, useRef } from 'react';
import { cstTime } from '../lib/time';

export default function TerminalLog({ events = [], height = 260, testId = 'terminal-log' }) {
  const endRef = useRef(null);
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [events.length]);

  const color = (lvl) => {
    if (lvl === 'good') return 'text-buy';
    if (lvl === 'warn') return 'text-hold';
    if (lvl === 'alert') return 'text-sell';
    return 'text-cyan-sys';
  };
  return (
    <div
      data-testid={testId}
      className="scanlines bg-[var(--bg-void)] border border-[var(--border-default)] overflow-y-auto font-mono text-[12px] leading-[1.55] px-3 py-2"
      style={{ height }}
    >
      {events.length === 0 && (
        <div className="text-[var(--txt-muted)]">// awaiting data feed...</div>
      )}
      {events.map((e, i) => {
        const t = e.t ? cstTime(e.t) : '--:--:-- CST';
        return (
          <div key={i} className="whitespace-pre-wrap">
            <span className="text-[var(--txt-muted)]">[{t}]</span>{' '}
            <span className={color(e.level)}>{e.text}</span>
          </div>
        );
      })}
      <div className="text-cyan-sys">
        <span>&gt; </span><span className="blink">_</span>
      </div>
      <div ref={endRef} />
    </div>
  );
}
